import { render, staticRenderFns } from "./WritingBlankType4Form.vue?vue&type=template&id=76ee95a7&"
import script from "./WritingBlankType4Form.vue?vue&type=script&lang=js&"
export * from "./WritingBlankType4Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports